import  PolicyDetails from './common/PolicyDetails';

// A component to render multiple policies
const InsurancePoliciesView = ({ policies, onReupload }) => {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-4 text-center">
        Your Insurance Policies
      </h1>
      {policies.map((policy, index) => (
        <div key={policy.id || index} className="border rounded-lg shadow-sm">
          <PolicyDetails policy={policy} onReupload={onReupload} />
        </div>
      ))}
    </div>
  );
};

export default InsurancePoliciesView;
